{"id":"StickyBox","prefabs":{"default":{"children":[{"component":"StickyBox","options":"options:*"}]}}}